import { useTranslation } from 'react-i18next';

/** Active/Inactive status chip — matches admin and workflow list screens (`pill p-com` / `pill p-arc`). */
export function MetadataActiveStatusPill({ active }: { active: boolean }) {
  const { t } = useTranslation();
  return (
    <span className={`pill ${active ? 'p-com' : 'p-arc'}`}>
      {active ? t('common.active') : t('common.inactive')}
    </span>
  );
}
